import { render, staticRenderFns } from "./Text1Content.vue?vue&type=template&id=48a544f6&"
import script from "./Text1Content.vue?vue&type=script&lang=js&"
export * from "./Text1Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports